import { Service, ServiceInitializer } from 'elc-service';
import { ServiceStartedUseCase } from '../internal/use-cases/ServiceStartedUseCase';
export interface IConfig {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

const packageInfo = require('../../package.json');
const { name, version } = packageInfo;

export class ConfigManagerService extends Service {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
        this.start = this.start.bind(this);
    }

    public async start(props: {}) {
        void super.start(props);
        try {
            await this.setupRepository(props);
        } catch (err) {
            console.error(err);
        }
    }
    private setupRepository = async (props: IConfig) => {
        const businessUnitId = props.businessUnitId;
        const setupRepositoryUseCase = new ServiceStartedUseCase(businessUnitId, props);
        await setupRepositoryUseCase.execute();
    };
}
